module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_6000.c2ba64a9.png";